<script>
import Vertical from "./vertical";

export default {
  components: { Vertical },
  data() {
    return {
        searchFilter:"",
    };
  },
  computed: {
    layoutType() {
      return this.$root.layoutType;
    },

  },
    watch:{
        searchFilter: function (value) {
            // console.log("third");
            // console.log(value) // log it BEFORE model is changed
            this.$emit('CustomEventInputChangedAll', value);
        }
    },
  methods: {
      searchFilterFuncMain(val) {
          this.searchFilter=val;
          // console.log("2");
          // console.log(val);
          // this.$emit('CustomEventInputChanged2', val);
      },
  },
};
</script>

<template>
  <div>
    <vertical @CustomEventInputChangedMain="searchFilterFuncMain">
      <slot />
    </vertical>
  </div>
</template>
